// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"DTGSizesList_contentComponent__1zdZu","tableContainer":"DTGSizesList_tableContainer__2fzho"};